"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _default = exports["default"] = (0, _styledComponents.keyframes)(["0%,100%{opacity:0.5;}50%{opacity:1;}"]);